<template>
  <div class="container">
    <div class="title"><span>首页</span>>  帮助中心</div>
    <div class="neir">
      <div class="l">
        <ul class="lB">
          <li v-for="item in pagelist" :key="item.id">
          <img :src="item.picUrl" alt="">
          <div>
            <h3 class="tit">{{item.name}}</h3>
            <p class="js">
              {{item.introduction}}
            </p>
            <p>
              <span>{{item.createTime}}</span>
              <span>阅读{{item.viewNum}}+</span>
            </p>
          </div>
        </li>
        </ul>
        <div class="page">
          <el-pagination
            background
            layout="pager"
            :total="total"
            @current-change="chanePage"
          >
          </el-pagination>
        </div>
      </div>
      <div class="r">
        <div class="t">
          <div class="lT">
            <ul class="list">
              <li class="active">好文推荐 <p></p></li>
            </ul>
          </div>
          <ul class="lB">
            <li v-for="item in pagelist2" :key="item.id" @click="goinfo(item.id)">
              <img :src="item.picUrl" alt="">
              <div>
                <h3>{{item.name}}</h3>
                <p>好评1720</p>
              </div>
            </li>
          </ul>
        </div>
        <!--<div class="b">-->
        <!--<p class="tip">阅读排行</p>-->
          <!--<ul>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
            <!--<li><i></i>PET-CT能不能检查出肺癌？PETCT能够检查出肺癌，特别是对早期的肺癌，PETCT的检出率更高一些。PET-CT可以 高度 拷贝</li>-->
          <!--</ul>-->
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
  // import commonTable from '@/components/commonTable.vue'
  import server from '@/service/server.js'
export default {
    name: 'index',
  components: {
    // commonTable
  },
    data () {
        return {
          showHeader: false,
          pagelist: [],
          pagelist2: [],
          current: 1,
          total: 0
        }
    },
    methods: {
      goinfo(id) {
        this.$router.push({
          path: `/yyznxq?id=${id}&type=zx`
        })
      },
      list() {
        server.helpPage({
          current: this.current,
          size: 10
        }).then((res) => {
          this.pagelist = res.data.records
          this.total = res.data.total
        })
      },
      list2() {
        server.informationTj(1).then((res) => {
          this.pagelist2 = res.data
        })
      },
      chanePage(e) {
        this.current = e
        this.list()
      }
    },

    mounted(){
      this.list()
      this.list2()
    }

}
</script>
<style lang="scss" scoped>
  .container {
    width: 1370px;
    margin: 0 auto;
    .title {
      padding: 10px 20px;
      background-color: #FFFFFF;
      margin: 20px 0;
      font-size: 16px;
      span {
        color: #5288F0;
      }
    }
    .neir{
      display: flex;
      .l{
        width: 1010px;
        background-color: #fff;
        padding-top: 10px;
        .lB{
          width: 100%;
          padding: 0 20px;
          li{
            border-bottom: 1px solid rgba(209, 213, 213, 1);
            display: flex;
            margin-top: 10px;
            padding-bottom: 10px;
            img{
              width: 163px;
              height: 161px;
            }
            div{
              padding: 10px 0;
              margin-left: 40px;
              width: calc(100% - 280px);
              h3{
                font-size: 19px;
                /*font-family: Adobe Heiti Std;*/;
                font-weight: normal;
                color: #000000;
              }
              p:nth-child(2){
                margin: 10px 0;
                height: 70px;
              }
              p{
                font-size: 16px;
                /*font-family: KaiTi;*/
                /*font-weight: 400;*/
                color: #888;
              }
              p:nth-child(3){
                display: flex;
                span:nth-child(2){
                  margin-left: auto;
                  font-size: 16px;
                  font-family: KaiTi;
                  font-weight: 400;
                }
              }
            }
          }
        }
        .page {
          padding: 30px;
          text-align: center;
        }
      }
      .r{
       margin-left: auto;
        .t{
          width: 344px;
          height: 587px;
          background: #FFFFFF;
          border: 1px solid #EAEBEB;
          border-radius: 5px;
          .lT{
            width: 100%;
            .list{
              margin-bottom: 10px;
              li{
                text-align: center;
                cursor: pointer;
                font-size: 19px;
                /*font-family: Adobe Heiti Std;*/;
                font-weight: normal;
                color: #000000;
                line-height: 33px;
                padding-top: 10px;
                border-bottom: 2px solid #EAEBEB;;
                p{
                  width: 97px;
                  height: 4px;
                  background: rgba(0, 180, 247, 0);
                  margin: 10px auto 0;
                }
              }
              li.active{
                p{
                  background: rgba(0, 180, 247, 1);
                }
              }
            }
          }
          .lB{
            width: 100%;
            padding: 0 20px;
            li{
              display: flex;
              margin-bottom: 20px;
              img{
                width: 103px;
                height: 72px;
              }
              div{
                padding: 4px 0;
                margin-left: 10px;
                width: calc(100% - 140px);
                h3{
                  font-size: 15px;
                  /*font-family: Adobe Heiti Std;*/;
                  font-weight: normal;
                  color: #040000;
                  width: 100%;
                  overflow:hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                p{
                  font-size: 14px;
                  /*font-family: Adobe Heiti Std;*/;
                  font-weight: normal;
                  color: #E1E4EA;
                  margin-top: 15px;
                }
              }
            }
          }
        }
        .b{
          margin-left: 16px;
          margin-top: 36px;
          width: 323px;
          height: 581px;
          border: 1px solid #E1E3EA;
          box-shadow: 0px 3px 7px 0px rgba(35,24,21,0.35);
          border-radius: 15px;
          padding: 10px;
          p{
            font-size: 21px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #000000;
            border-bottom: 1px solid rgba(210, 214, 214, 1);
            line-height: 32px;
            padding: 5px 0;
          }
          ul{
            li{
              i{
                width: 6px;
                height: 6px;
                background: #000;
                border-radius: 50%;
                display: inline-block;
                vertical-align: middle;
                margin-right: 10px;
              }
              font-size: 17px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #000000;
              width: calc(100% - 20px);
              overflow:hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
  @media (max-width: 750px) {

    .container {
      width: 100%;
      margin-top: 60px;
      .neir {
        display: block;
        .r {
          display: none;
        }
        .l {
          width: 100%;
          .lT {
            .list {
              li {
                font-size: 16px;
                margin-left: 20px;
              }
            }
            .neirList {
              li {
                padding: 0 10px;
                height: 30px;
                line-height: 30px;
              }
            }
          }

          .lB {
            li {
              padding-bottom: 15px;
              margin-top: 15px;
              img {
                display: none;
              }
              div {
                padding: 0;
                margin-left: 15px;
                width: calc(100%);
                .tit {
                  font-size: 16px;
                  padding-top: 5px;
                }
                .js {
                  font-size: 14px;
                  margin-bottom: 0 !important;
                  height: auto !important;
                  line-height: 24px;
                }
                .time {

                }
              }
            }

          }



        }
      }
    }
  }
</style>
